module.exports = __webpack_public_path__ + "static/media/swimmy-logo.7d60a522.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/swimmy-logo.png
// module id = 1924
// module chunks = 0